import ZwxSign from "./Index.vue";

ZwxSign.install = function(Vue) {
  Vue.component(ZwxSign.name, ZwxSign);
};

export default ZwxSign;
